import "./privacyPolicy.css";
import Header from '../shared/header/header';
import React, { useRef, useState, useEffect } from 'react';
import Footer from '../shared/footer/footer';
import useGetdata from '../../Hooks/useGetData';
import { useSelector } from 'react-redux';
import SnackbarNav from '../main/SnackbarNav/SnackbarNav';
import MobileMenu from '../main/SnackbarNav/MobileMenu';

const privacySections = [
    {
        id: "commitment",
        title: "Our Commitment To Privacy",
        type: "text",
        content: `Skye Air Mobility Private Limited is committed to protecting the personal data of all
individuals who interact with this website, whether as general visitors, enquiry
submitted, newsletter subscribers, all authorised riders using the COD deposit
portal. This privacy policy explains what data we collect, why we collect it, how old
is used, and your rights under India’s Digital Personal PData protection Act, 2023
(DPDP Act).`
    },
    {
        id: "data-collection",
        title: "Categories Of Personal Data Collected",
        type: "grouped-list",
        groups: [
            {
                title: "A. From Website Visitors (via Forms)",
                points: [
                    "Name & Contact Details: Full name, email address, phone number.",
                    "Business / Company Information: Organization name, designation, industry, and nature of business submitted via enquiry or partner interest forms.",
                    "Enquiry Content: Subject and message body submitted through contact forms.",
                    "Newsletter Preference: Email address and communication opt-in status."
                ]
            },
            {
                title: "B. From riders (COD Deposit Portal)",
                points: [
                    "Rider ID or employee/partner identification number.",
                    "Mobile number linked to the payment instrument used for deposit.",
                    "Transaction details: amount deposited, delivery id, timestamp, payment status, and reference number.",
                    "Device metadata and IP address at time of transaction (for security and fraud prevention)."
                ]
            },
            {
                title: "C. Automatically Collected Data (All Users)",
                points: [
                    "IP address, browser type, operating system, and device type.",
                    "Pages visited, time on site, referral source, and navigation patterns.",
                    "Cookies and session data."
                ]
            },
            {
                title: "D. Client and Partner Information Published on Website",
                content: "Information about Skye Air Mobility’s business clients and partners (e.g., company names, logos, testimonials, case studies) may be displayed on this website with prior consent, governed by applicable commercial agreements. No personally identifiable data of client employees is published without explicit individual consent.",
            }
        ]
    },

    {
        id: "purpose",
        title: "Purpose Of Data Processing",
        type: "list",
        // content: "",
        points: [
            "Responding to Enquiries: Contacting visitors who submit enquiries or partner interest forms.",
            "Newsletter Communications: Sending service updates and news to opted-in subscribers.",
            "COD Portal Operations: Processing, recording, and reconciling Rider deposits against delivery records.",
            "Fraud Prevention and Security: Detecting unauthorised access, suspicious transactions, and misuse of the Portal.",
            "Legal and Regulatory Compliance: Meeting obligations under GST law, RBI guidelines, DGCA regulations, and other applicable statutes.",
            "Website Analytics: Understanding usage patterns to improve functionality and content.",
            "Business Development: Managing relationships with prospective partners and client "
        ],
    },

    {
        id: "shareData",
        title: "Who We Share Data With",
        type: "list",
        content: "Skye Air Mobility does not sell or rent personal data. We may share data with the following parties:",
        points: [
            "Payment Gateway Provider: Transaction data shared with our integrated payment gateway to process COD deposits. The Gateway Provider complies with PCI-DSS standards and RBI regulations.",
            "Cloud & Hosting Providers: Infrastructure partners bound by data processing agreements.",
            "Analytics Platforms: Aggregated, anonymised usage data may be shared with analytics tools such as Google Analytics.",
            "Franchise & Delivery Partners: Rider transaction data relevant to a specific partner’s operations may be shared for reconciliation purposes.",
            "Government & Regulatory Authorities: When required by law including RBI, DGCA, income tax authorities, or law enforcement agencies."
        ],
    },
    {
        id: "cookies-tracking",
        title: "Cookies And Tracking Technologies",
        type: "list-with-footer",
        content:
            "We use cookies to support website functionality, analyse traffic, and personalize content. Cookie types in use:",
        points: [
            {
                label: "Essential Cookies",
                desc: "Required for the website and Portal to operate. Cannot be disabled."
            },
            {
                label: "Analytics Cookies",
                desc: "Collect anonymised data to help us understand and improve website usage."
            },
            {
                label: "Session Cookies",
                desc: "Temporary; expire when you close your browser. Used during Portal login sessions."
            },
            {
                label: "Marketing Cookies (with consent)",
                desc: "Track campaign performance and serve relevant content."
            }
        ],
        footer:
            "Non-essential cookies may be managed via your browser settings and will not affect access to the COD Portal or core website content."
    },
    // {
    //     id: "data-sharing",
    //     title: "Data Sharing",
    //     type: "list-bold",
    //     content: "We do not sell your personal information. We may share data only in the following circumstances:",
    //     points: [
    //         { label: "Service Providers", desc: "Trusted partners who assist in platform operations" },
    //         { label: "Legal Requirements", desc: "When required by law or to protect rights and safety" },
    //         { label: "Business Transfers", desc: "In the event of a merger, acquisition, or asset sale" }
    //     ]
    // },
    // {
    //     id: "cookies",
    //     title: "Cookies",
    //     type: "text-box",
    //     content: "We use cookies and similar tracking technologies to enhance your experience.",
    //     boxContent: "You can control cookie preferences through your browser settings. Note that disabling certain cookies may limit functionality."
    // },
    // {
    //     id: "retention",
    //     title: "Data Retention",
    //     type: "text",
    //     content: "We retain personal information only as long as necessary for the purposes outlined in this policy."
    // },
    // {
    //     id: "updates",
    //     title: "Policy Updates",
    //     type: "text-multi",
    //     paragraphs: [
    //         "We may update this Privacy Policy periodically. When significant changes occur, we will notify you via email or platform notification.",
    //         "Continued use of our services after updates indicates acceptance of the revised policy."
    //     ]
    // },

    {
        id: "payment-disclaimer",
        title: "Payment Disclaimer",
        type: "complex",
        blocks: [
            {
                type: "text",
                content: [
                    "Skye Air Mobility (“Company”) facilitates the deposit of Cash-on-Delivery (COD) amounts through third-party payment gateway service providers (“Payment Aggregators”) in accordance with applicable laws and guidelines issued by the Reserve Bank of India.",
                    "The Company is not a payment system operator and does not provide payment aggregation services directly. All payment transactions are processed through authorized Payment Aggregators and are subject to their respective terms, conditions, and privacy policies."
                ]
            },
            {
                type: "list",
                title: "The Company shall not be liable for:",
                points: [
                    "Any delay, failure, or disruption of payment processing due to technical issues, banking network failures, or payment gateway downtime;",
                    "Any incorrect payment details entered by users, including employees, riders, or authorized personnel;",
                    "Unauthorized transactions resulting from negligence, misuse, or compromise of user credentials;",
                    "Any loss arising from actions or omissions of third-party payment service providers."
                ]
            },
            {
                type: "text",
                content: [
                    "All users depositing COD amounts are solely responsible for ensuring the accuracy of transaction details and timely remittance of collected funds.",
                    "All transactions are subject to verification, reconciliation, and compliance checks in accordance with applicable regulatory requirements, including Know Your Customer (KYC) norms and anti-money laundering laws."
                ]
            },
            {
                type: "list",
                title: "By proceeding with any transaction on this platform, users acknowledge and agree that:",
                points: [
                    "The Company acts only as a facilitator for operational convenience;",
                    "The ultimate settlement of funds is subject to banking and payment gateway processes;",
                    "Disputes relating to payment processing may be subject to the jurisdiction and policies of the respective Payment Aggregator."
                ]
            },
            {
                type: "text",
                content: [
                    "For any payment-related grievances, users may contact the Company’s Grievance Officer or the respective Payment Aggregator."
                ]
            }
        ]
    }
];

const PrivacyPolicy = () => {
    const sectionRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 480);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 480);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useGetdata();
    const data = useSelector((store) => store.data.HomeData);

    useEffect(() => {
        const handleScroll = () => {
            const links = document.querySelectorAll(".nav-link");
            privacySections.forEach((sec) => {
                const el = document.getElementById(sec.id);
                if (!el) return;
                const rect = el.getBoundingClientRect();
                if (rect.top <= 150 && rect.bottom >= 150) {
                    links.forEach((l) => l.classList.remove("active"));
                    document.querySelector(`[data-link="${sec.id}"]`)?.classList.add("active");
                }
            });
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className="terms-page-wrapper">
            <div ref={sectionRef} className="contact-container">
                <div className="terms-home-container">
                    <Header />
                </div>
            </div>

            <div className="terms-page">
                <div className="terms-hero">
                    <div className="overlay">
                        <p className="breadcrumb">LEGAL / POLICIES</p>
                        <h1>Privacy Policy</h1>
                        <p className="subtitle">
                            Your privacy and data security are our top priorities.
                        </p>
                        <p className="last-updated" style={{ fontSize: '0.8rem', marginTop: '10px', opacity: 0.7 }}>
                            Last Updated: March 26, 2026
                        </p>
                    </div>
                </div>

                <div className="terms-body">
                    {!isMobile && (
                        <div className="terms-sidebar">
                            <p className="sidebar-title">QUICK NAVIGATION</p>
                            {privacySections.map((item) => (
                                <a
                                    key={item.id}
                                    href={`#${item.id}`}
                                    data-link={item.id}
                                    className="nav-link"
                                >
                                    {item.title}
                                </a>
                            ))}
                        </div>
                    )}

                    <div className="terms-content">
                        {privacySections.map((sec) => (
                            <section key={sec.id} id={sec.id}>
                                <h2>{sec.title}</h2>
                                <hr />

                                {sec.type === "text" && <p>{sec.content}</p>}

                                {sec.type === "text-multi" && sec.paragraphs.map((p, i) => <p key={i}>{p}</p>)}

                                {sec.type === "list" && (
                                    <>
                                        <p>{sec.content}</p>
                                        {sec.points && (
                                            <ul>{sec.points.map((p, i) => <li key={i}>{p}</li>)}</ul>
                                        )}
                                        {sec.subsections && sec.subsections.map((sub, i) => (
                                            <div key={i} className="policy-subsection">
                                                <h5 style={{ color: '#fff' }}>{sub.subtitle}</h5>
                                                <ul>{sub.points.map((p, j) => <li key={j}>{p}</li>)}</ul>
                                            </div>
                                        ))}
                                    </>
                                )}

                                {sec.type === "list-bold" && (
                                    <>
                                        <p>{sec.content}</p>
                                        <ul>
                                            {sec.points.map((p, i) => (
                                                <li key={i}><strong>{p.label}:</strong> {p.desc}</li>
                                            ))}
                                        </ul>
                                        {sec.footer && <p className="contact-link">{sec.footer}</p>}
                                    </>
                                )}

                                {sec.type === "text-box" && (
                                    <>
                                        <p>{sec.content}</p>
                                        <div className="policy-note-box">
                                            <p>{sec.boxContent}</p>
                                        </div>
                                    </>
                                )}

                                {sec.type === "grouped-list" && (
                                    <>
                                        {sec.groups.map((group, i) => (
                                            <div key={i} className="policy-group">

                                                <h4 className="group-title">{group.title}</h4>

                                                {group.content && <p>{group.content}</p>}

                                                {group.points && (
                                                    <ul className="blue-bullet-list">
                                                        {group.points.map((point, j) => (
                                                            <li key={j}>{point}</li>
                                                        ))}
                                                    </ul>
                                                )}

                                            </div>
                                        ))}
                                    </>
                                )}

                                {sec.type === "list-with-footer" && (
                                    <>
                                        <p>{sec.content}</p>

                                        <ul className="blue-bullet-list">
                                            {sec.points.map((item, i) => (
                                                <li key={i}>
                                                    <strong>{item.label}:</strong> {item.desc}
                                                </li>
                                            ))}
                                        </ul>

                                        {sec.footer && <p className="policy-footer">{sec.footer}</p>}
                                    </>
                                )}

                                {sec.type === "complex" && (
                                    <>
                                        {sec.blocks.map((block, i) => (
                                            <div key={i} className="complex-block">

                                                {block.type === "text" &&
                                                    block.content.map((p, j) => (
                                                        <p key={j}>{p}</p>
                                                    ))}

                                                {block.type === "list" && (
                                                    <>
                                                        {block.title && <p className="list-title">{block.title}</p>}
                                                        <ul className="blue-bullet-list">
                                                            {block.points.map((point, k) => (
                                                                <li key={k}>{point}</li>
                                                            ))}
                                                        </ul>
                                                    </>
                                                )}

                                            </div>
                                        ))}
                                    </>
                                )}
                            </section>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />

            <section>
                {!isMobile && <SnackbarNav />}
                {isMobile && !menuOpen && (
                    <button className="menu-toggle" onClick={() => setMenuOpen(true)}>
                        ☰
                    </button>
                )}
                {isMobile && menuOpen && (
                    <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
                )}
            </section>

        </div>
    );
};

export default PrivacyPolicy;